<template>
  <div class="blog-card">
    <img :src="photo" alt="">
    <div class="blog-card__inner">
      <span class="blog-card__target">{{ target }}</span>
      <b>{{ title }}</b>
      <p class="blog-card__excerpt">{{ author }}</p>

      <div class="blog-card__bottom">
        <span class="date-tag">{{ created_at.split('T')[0] }}</span>
        <button
            class="blog-card__cta"
            type="button"
            @click="() => $router.push({path: `/blog/entry/${id}`, query:{name: title.toLowerCase().split(' ').join('-')}})"
        >
          Czytaj dalej
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  name:'BlogPostCardVue',
  props:['url', 'title', 'author', 'photo', 'id', 'target', 'created_at']
}
</script>

<style scoped lang='scss'>
.blog-card{
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 12px;
  background-color: #fff;
  border: 1px solid #f3f4f6;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .05);
  min-height: 430px;
  transition: box-shadow .2s ease, transform .2s ease;
  &:hover{
    transform: translateY(-2px);
    box-shadow: 0 16px 28px rgba(0,0,0,.12);
  }

  img{
    width: 100%;
    height: 190px;
    object-fit: cover;
  }

  &__inner{
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 14px;
    height: 100%;
  }

  &__target{
    display: inline-block;
    width: fit-content;
    font-size: 1.2rem;
    color: #6b7280;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    padding: 4px 8px;
    border-radius: 999px;
  }

  b{
    text-align: left;
    font-size: 2rem;
    color: #111827;
    line-height: 1.3;
    margin: 0;
  }

  &__excerpt{
    margin: 0;
    color: #4b5563;
    font-size: 1.4rem;
    line-height: 1.5;
    flex-grow: 1;
  }

  &__bottom{
    margin-top: auto;
    padding-top: 12px;
    border-top: 1px solid #e5e7eb;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  .date-tag{
    font-size: 1.3rem;
    color: #9ca3af;
  }

  &__cta{
    border: none;
    background: transparent;
    color: #10b981;
    font-size: 1.4rem;
    font-weight: 700;
    cursor: pointer;
    padding: 0;
    transition: color .2s ease;
    &:hover{
      color: #059669;
      text-decoration: underline;
    }
  }
}
</style>